export const css = {
	root: '_32fujPZn',
	listItem: '_18MPRvlL',
	' _key': 'certwise-theme/dojo/breadcrumb-group'
};

export default css;
